import React, { useEffect, useRef } from 'react';

const Banner = () => {

    const carouselRef = useRef(null);

    useEffect(() => {
        if (carouselRef.current && window.bootstrap) {
            new window.bootstrap.Carousel(carouselRef.current, {
                interval: 3500,
                ride: 'carousel',
            });
        }
    }, []);

    return (
        <div id="bannerSec" className="carousel slide bannerSec" ref={carouselRef}>
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <a target='_blank' rel="noreferrer" href='https://innovateindia.mygov.in/baalpan-ki-kavita/'> <img src="assets/images/banner/kavita_banner_eng.jpg" className=" w-100" alt="banner" /></a>
                </div>
                <div className="carousel-item">
                    <a target='_blank' rel="noreferrer" href='https://innovateindia.mygov.in/baalpan-ki-kavita/'> <img src="assets/images/banner/kavita_banner_hindi.jpg" className=" w-100" alt="banner" /></a>
                </div>
                <div className="carousel-item">
                    <img src="assets/images/banner/banner.gif" className=" w-100" alt="banner" />
                </div>
                <div className="carousel-item">
                    <img src="assets/images/banner/banner_2.gif" className=" w-100" alt="banner" />
                </div>

            </div>
            <button className="carousel-control-prev bannerbtn" type="button" data-bs-target="#bannerSec" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            </button>
            <button className="carousel-control-next bannerbtn" type="button" data-bs-target="#bannerSec" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
            </button>

            <div className="carousel-indicators mb-0">
                <button type="button" data-bs-target="#bannerSec" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#bannerSec" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#bannerSec" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#bannerSec" data-bs-slide-to="3" aria-label="Slide 4"></button>

            </div>

        </div>
    )
}

export default Banner